export const SET_SHOW_SHOW_APPROVE_REQUESTED_FUNDS_ALERT = 'SET_SHOW_SHOW_APPROVE_REQUESTED_FUNDS_ALERT';